import { postJson } from '../config/HttpClient'

export interface HistoricoFacturaPOS {
  nome_cliente: string
  data_emissao: string
  tipo: string
  codigo_factura: string
  code_factura: string
  total_final: string
}

export interface HistoricoCaixaPOS {
  dataAbertura: string
  dataFecho: string | null
  valorAbertura: number
  valorFecho: number | null
  estado: string
  vendedor: string
}

class HistoricoService {
  async historicoFacturas(page = 0): Promise<HistoricoFacturaPOS[]> {
    return postJson<HistoricoFacturaPOS[]>(`/api-pos/historico-pos/lista-historico-facturas?page=${page}`)
  }

  async historicoCaixa(page = 0): Promise<HistoricoCaixaPOS[]> {
    return postJson<HistoricoCaixaPOS[]>(`/api-pos/historico-pos/lista-historico-caixa?page=${page}`)
  }
}

export default new HistoricoService()
